import styles from "./Winners.module.scss"
import contest_arrow from "../../../../assets/img/contest_arrow.svg";
import contest_page_img from "../../../../assets/img/contest-page-img.svg";
import contestImg from "../../../../assets/img/contest.svg";
import {useNavigate} from "react-router-dom";
import {Table} from "./Table/Table";
import {useEffect, useRef} from "react";
import { useDispatch, useSelector } from "react-redux";
import { getResult } from "../../NewYearEvent/eventSlice";

const Winners = () => {
    const token = useSelector(state => state.loginSlice.token);
    const contest = localStorage.getItem('contestID')
    const loading = useSelector(state => state.eventSlice.resultsLoading)
    const results = useSelector(state => state.eventSlice.results)
    const navigate = useNavigate()
    const tableRef = useRef(null);
    const dispatch = useDispatch()

    console.log(results ? results?.results_description : '');

    const scrollToTable = () => {
        tableRef.current.scrollIntoView({ behavior: 'smooth' });
    };

    useEffect(() => {
        dispatch(getResult({token, contest}))
    },[dispatch])

    return (
        <section className="main">
            <div className="content-wrapper">
        <div className={styles.winnersContainer}>
            <button
                className={styles.goBackBtn}
                onClick={() => navigate("/")}
            >
                <img src={contest_arrow} alt={""}/>
                <p>Главная</p>
            </button>
            {/*<div className={styles.contestBannerContainer}>*/}
            {/*                <div className={styles.contestDescription}>*/}
            {/*                    <div className={styles.cardTitleContainer}>*/}
            {/*                    /!* <h1 className={styles.contestHeading}>{contest?.name}</h1> *!/*/}
            {/*                    <h1 className={styles.contestHeading}>Результаты конкурса «{results.name}»</h1>*/}
            {/*                    <p className={styles.contestText}>Конкурс завершен!</p>*/}
            {/*                    </div>*/}
            {/*                    <button onClick={() => {scrollToTable()}} className={styles.contestBtn}>*/}
            {/*                        Результаты*/}
            {/*                    </button>*/}
            {/*                </div>*/}
            {/*                <div className={styles.imgContainer}>*/}
            {/*                    <img src={contestImg} alt="Конкурс" className={styles.contestImg}/>*/}
            {/*                </div>*/}

            {/*            </div>*/}
            <div className={styles.conditionContainer}>
                        <h1 className={styles.conditionText}>Результаты конкурса «{results.name}»</h1>
                        <p className={styles.conditionDescription}>
                            <div dangerouslySetInnerHTML={{__html: results?.results_description?.toString()}}></div>
                            {/*{htmlToText(contestsData?.terms)}*/}
                        </p>
                    </div>
            <h2 ref={tableRef} className={styles.tableHeading}>Победители розыгрыша</h2>
            <Table data={results}/>
        </div>
        </div>
        </section>
    )
}

export {Winners}